import { Consumer, createConsumer, Subscription } from '@rails/actioncable'
import Cookies from 'js-cookie'

let consumer: Consumer | null = null
let holders = 0

const channels: Array<{ forceReset: () => void }> = []

export const createCableUrl = () => {
  const uid = Cookies.get('uid')
  const accessToken = Cookies.get('access-token')
  const client = Cookies.get('client')
  const apiBaseUrl = process.env.REACT_APP_API_URL

  if (!uid || !accessToken || !client || !apiBaseUrl) return null

  const wsBaseUrl = apiBaseUrl
    .trim()
    .replace(/\/+$/, '')
    .replace(/^http:/, 'ws:')
    .replace(/^https:/, 'wss:')

  return `${wsBaseUrl}/cable?uid=${encodeURIComponent(uid)}&access-token=${encodeURIComponent(
    accessToken
  )}&client=${encodeURIComponent(client)}`
}

export const acquireCable = (): Consumer | null => {
  if (typeof window === 'undefined') return null

  const url = createCableUrl()
  if (!url) return null

  holders += 1
  if (consumer) return consumer

  try {
    consumer = createConsumer(url)
    return consumer
  } catch (error) {
    holders = Math.max(0, holders - 1)
    consumer = null
    throw error
  }
}

export const releaseCable = () => {
  if (holders === 0) return

  holders -= 1
  if (holders > 0) return

  consumer?.disconnect()
  consumer = null
}

type ReceivedHandler = (message: unknown) => void

export const createChannelSubscription = (channel: string, label: string) => {
  let subscription: Subscription | null = null
  let subscribers = 0
  let held = false

  const ensure = (received: ReceivedHandler) => {
    subscribers += 1
    if (subscription) return

    try {
      const cable = acquireCable()
      if (!cable) return

      held = true
      subscription = cable.subscriptions.create({ channel }, { received })
    } catch (error) {
      if (held) {
        held = false
        releaseCable()
      }
      console.error(`${label} ActionCable setup failed:`, error)
    }
  }

  const release = () => {
    subscribers = Math.max(0, subscribers - 1)
    if (subscribers > 0) return

    subscription?.unsubscribe()
    subscription = null
    if (held) {
      held = false
      releaseCable()
    }
  }

  const forceReset = () => {
    subscription = null
    subscribers = 0
    held = false
  }

  channels.push({ forceReset })
  return { ensure, release }
}

export const resetCableForTests = () => {
  channels.forEach(channel => channel.forceReset())
  consumer?.disconnect()
  consumer = null
  holders = 0
}
